export const errorCatalog = {
    // ===== 500 — عندنا، لا عند المستخدم =====
    /**
     * **بيئةُ التشغيل ناقصة — فلا يُقلَع.**
     *
     * **وهو أوّلُ خطأٍ ممكنٍ في عمر النظام**، ولا يصل متصفّحاً أبداً: العمليةُ
     * تطبع أسماءَ ما نقص وتخرج. **ومع ذلك كودُه هنا** لأن من يُنصِّب يقرؤه
     * ويقتبسه، وشاشةُ كتالوج الأخطاء تُولَد من هذا الجدول.
     *
     * **والسببُ أنه كان لا يقع**: ثلاثةُ متغيّراتٍ لها بدائلُ صحيحةٌ في التطوير
     * **خطأٌ في الإنتاج** — ففلفلُ الجلسات كان بديلُه مطبوعاً في سورسٍ يُباع،
     * **فمن نسيه أقلع سليماً تماماً** ودخل من قرأ الكودَ بجلسةٍ يصنعها بنفسه.
     */
    ENV_NOT_CONFIGURED: {
        status: 500,
        messageKey: "errors.envNotConfigured",
        contextKeys: ["names"],
        incident: true,
        cause: {
            ar: "متغيّرٌ لازمٌ غائبٌ من بيئة التشغيل، أو بديلُه للتطوير وحده ولا يصحّ في الإنتاج.",
            en: "A required environment variable is missing, or its fallback is development-only and unsafe in production.",
        },
        remedy: {
            ar: "الرسالةُ تسمّي المتغيّراتَ كلَّها بسببها. ضعها في ملفِّ بيئةِ التنصيب (`.env.example` يشرح كلَّ واحد) وأعد التشغيل.",
            en: "The message names every variable and why. Put them in the installation's environment file (`.env.example` explains each) and start again.",
        },
    },
    /**
     * **أمرٌ يمسح البيانات، شُغِّل على تنصيبٍ إنتاجيّ — فرُفض قبل أن يمسّ صفّاً.**
     *
     * **وكان يُرفَض بكود `FORBIDDEN`**، ونصُّ ذلك الكود: «المستخدم لا يحمل هذه
     * القدرة بأيّ نطاق» وعلاجُه «الشاشة تعرض زرّ اطلب الصلاحية». **فمن شغّل بذرةً
     * على سيرفرٍ قرأ أن صلاحيتَه ناقصة** — فيبحث في الأدوار ساعةً، **والسببُ أن
     * الحارسَ رفض المسحَ أصلاً**.
     *
     * **ورسالةٌ تصف عطباً غيرَ الواقع أسوأُ من رسالةٍ عامّة**: الأولى تُرسِل
     * قارئَها إلى طريقٍ مسدود.
     */
    DESTRUCTIVE_IN_PRODUCTION: {
        status: 403,
        messageKey: "errors.destructiveInProduction",
        cause: {
            ar: "أمرٌ يمسح البيانات شُغِّل على تنصيبٍ إنتاجيّ. رُفض قبل أن يمسّ صفّاً — ولا علاقة للأمر بصلاحيات أحد.",
            en: "A data-erasing command ran against a production installation. It was refused before touching a row — this is not about anyone's permissions.",
        },
        remedy: {
            ar: "تصفيرُ القاعدة أداةُ تطويرٍ وديمو. لبذرِ تنصيبٍ حقيقيٍّ لا تمرّر `--reset`، فالبذرةُ تُضيف ولا تمسح. ولتصفير ديمو شغّله ببيئةٍ غيرِ إنتاجية.",
            en: "Resetting the database is a development and demo tool. To seed a real installation, omit `--reset` — seeding adds and never erases. To reset a demo, run it in a non-production environment.",
        },
    },
    INTERNAL: {
        status: 500,
        messageKey: "errors.internal",
        cause: {
            ar: "خطأ غير متوقّع في الكود أو في خدمة يعتمد عليها النظام.",
            en: "An unexpected fault in our code or in a service the system depends on.",
        },
        remedy: {
            ar: "افتح الحادثة برقم المرجع — فيها الطلب كامل ومكان العطل بالضبط.",
            en: "Open the incident by its reference — it carries the full request and the exact fault site.",
        },
        incident: true,
    },
    DEPENDENCY_UNAVAILABLE: {
        status: 503,
        messageKey: "errors.dependencyUnavailable",
        cause: {
            ar: "قاعدة البيانات أو التخزين أو فحص الملفات لا يستجيب.",
            en: "The database, storage, or file scanner is not responding.",
        },
        remedy: {
            ar: "راجع شاشة صحة النظام — الخدمة المتعطّلة ستكون حمراء، ومعها سبب مفهوم.",
            en: "Check System Health — the failing service shows red with a readable reason.",
        },
        incident: true,
    },
    /**
     * طلب أُلغي عن قصد — **ليس عطلاً عندنا ولا عنده**.
     *
     * له كود لأن كل شيء هنا له كود، ولكنه لا يُرفع حادثة ولا يُعرض كبانر خطأ.
     * والبديل أسوأ: أن يظهر خروجُك من شاشة على أنه «النظام مش شغّال» — رسالةٌ
     * كاذبة أسوأ من لا رسالة.
     */
    REQUEST_ABORTED: {
        status: 499,
        messageKey: "errors.requestAborted",
        cause: {
            ar: "الطلب أُلغي قبل أن يكتمل — غالباً لأن المستخدم خرج من الشاشة أو بدأ طلباً أحدث.",
            en: "The request was cancelled before it finished — usually because the user left the screen or a newer request replaced it.",
        },
        remedy: {
            ar: "لا شيء مطلوب. ولو بقيت الشاشة فارغة، فتحديثها يكفي.",
            en: "Nothing to do. If the screen stays blank, refreshing is enough.",
        },
    },
    /**
     * **نسخةٌ جديدةٌ نزلت والصفحةُ مفتوحةٌ على القديمة** — لا عطبٌ في الكود.
     *
     * فالشاشاتُ تُحمَّل حين تُفتَح، **وبعد كلّ رفعٍ تُحذف ملفاتُ النسخة السابقة**:
     * من كانت صفحتُه مفتوحةً يطلب ملفَّ شاشةٍ لم يعد موجوداً. وكان سيقرأ «خطأ غير
     * متوقّع» على ما ليس خطأ — **فرسالةٌ تقول السببَ وعلاجَه**: حدِّث الصفحة.
     */
    APP_UPDATED: {
        status: 409,
        messageKey: "errors.appUpdated",
        cause: {
            ar: "صدرت نسخةٌ جديدة من النظام والصفحةُ مفتوحةٌ على النسخة السابقة، فلم يُعثَر على ملفّ الشاشة.",
            en: "A new version was released while the page was open on the previous one, so the screen's file was not found.",
        },
        remedy: {
            ar: "حدِّث الصفحة — تُفتح النسخةُ الجديدة ولا يضيع شيءٌ محفوظ.",
            en: "Refresh the page — the new version opens and nothing saved is lost.",
        },
    },
    // ===== 400 — المدخلات =====
    VALIDATION_FAILED: {
        status: 400,
        messageKey: "errors.validationFailed",
        cause: {
            ar: "حقل ناقص أو بصيغة غير مقبولة. الخطأ يحمل أسماء الحقول بالتحديد.",
            en: "A missing or malformed field. The error names the exact fields.",
        },
        remedy: {
            ar: "الحقول المعلّمة في الشاشة هي نفسها الواردة في الخطأ — عدّلها وأعد المحاولة.",
            en: "The highlighted fields on screen are the ones in the error — fix and retry.",
        },
    },
    IDEMPOTENCY_KEY_MISSING: {
        status: 400,
        messageKey: "errors.idempotencyKeyMissing",
        cause: {
            ar: "عملية مُغيِّرة وصلت بلا مفتاح الحماية من التكرار — يعني نداءً لم يمرّ بغلاف الشبكة.",
            en: "A mutating call arrived without its duplicate-protection key — i.e. it bypassed the network wrapper.",
        },
        remedy: {
            ar: "لا شأن للمستخدم به. أي نداء خارج الغلاف عطبٌ برمجي يمسكه اختبار المعمارية.",
            en: "Not a user problem. Any call outside the wrapper is a defect the architecture test catches.",
        },
        incident: true,
    },
    // ===== 401 / 403 — الهوية والصلاحية =====
    SESSION_INVALID: {
        status: 401,
        messageKey: "errors.sessionInvalid",
        cause: {
            ar: "الجلسة انتهت أو أُلغيت — بتغيير كلمة سر، أو تسجيل خروج من كل الأجهزة، أو إلغاء إداري.",
            en: "The session expired or was revoked — by a password change, sign-out-everywhere, or an admin revoke.",
        },
        remedy: {
            ar: "تسجيل دخول جديد. تكرارها لنفس الشخص خلال دقائق يستحق النظر في جلساته.",
            en: "Sign in again. Repeated for one person within minutes, look at their sessions.",
        },
    },
    /**
     * دخول مرفوض — **ولا يقول أيُ نصفٍ كان الخطأ**.
     *
     * منفصل عن «جلستك انتهت» عمداً: من كتب كلمة خاطئة ليست له جلسة
     * انتهت، وقولها له رسالة كاذبة تجعله يدوّر في المكان الغلط. ورسالة غامضة
     * عن سبب الرفض شيء، ورسالة خاطئة عن نوعه شيء آخر.
     */
    SIGN_IN_REJECTED: {
        status: 401,
        messageKey: "errors.signInRejected",
        cause: {
            ar: "البريد أو كلمة السرّ غير صحيحة، أو الحساب غير نشط. والردّ واحد في الحالات الثلاث بقصد.",
            en: "The email or password is wrong, or the account is inactive. The reply is deliberately identical in all three cases.",
        },
        remedy: {
            ar: "راجع البريد والكلمة. ولو تكرّرت المحاولات، يتوقّف الدخول مؤقتاً — ومحاولات الدخول تقول من حاول ومن أين.",
            en: "Check the email and the password. Repeated attempts pause sign-in for a while — and the login-attempt log says who tried and from where.",
        },
    },
    PASSWORD_CHANGE_REQUIRED: {
        status: 401,
        messageKey: "errors.passwordChangeRequired",
        cause: {
            ar: "أول دخول بكلمة سر مؤقتة، أو إعادة تعيين إدارية.",
            en: "First sign-in with a temporary password, or an administrative reset.",
        },
        remedy: { ar: "يغيّرها المستخدم ويكمل.", en: "The user changes it and continues." },
    },
    FORBIDDEN: {
        status: 403,
        messageKey: "errors.forbidden",
        cause: {
            ar: "المستخدم لا يحمل هذه القدرة بأي نطاق.",
            en: "The user does not hold this capability at any scope.",
        },
        remedy: {
            ar: "الشاشة تعرض زرّ «اطلب الصلاحية» ويحمل اسم القدرة — لا رسالة رفض جافة.",
            en: "The screen shows a 'request permission' button naming the capability — never a bare refusal.",
        },
    },
    SCOPE_FORBIDDEN: {
        status: 403,
        messageKey: "errors.scopeForbidden",
        cause: {
            ar: "يحمل القدرة، لكن نطاقها لا يغطّي هذا السجل — قسم آخر أو عميل ليس عضواً فيه.",
            en: "Holds the capability, but its scope does not cover this record — another department, or a client they're not a member of.",
        },
        remedy: {
            ar: "إما عضوية العميل/القسم ناقصة، وإما النطاق على المنحة أضيق مما يلزم.",
            en: "Either a client/department membership is missing, or the grant's scope is narrower than needed.",
        },
    },
    STEP_UP_REQUIRED: {
        status: 403,
        messageKey: "errors.stepUpRequired",
        cause: {
            ar: "عملية من القائمة الكبيرة ومضى على آخر تحقّق أكثر من المدّة المسموحة.",
            en: "An operation on the major list, and the last verification is older than the allowed window.",
        },
        remedy: {
            ar: "يتحقّق المستخدم مرة ثانية ويكمل. ليس عطباً.",
            en: "The user verifies once more and continues. Not a fault.",
        },
    },
    // ===== 404 / 409 =====
    NOT_FOUND: {
        status: 404,
        messageKey: "errors.notFound",
        cause: {
            ar: "السجل غير موجود أو حُذف. ونستعملها أيضاً حيث يكون كشف الوجود نفسه تسريباً.",
            en: "The record doesn't exist or was deleted. Also used where revealing existence would itself leak.",
        },
        remedy: {
            ar: "إن كان المستخدم واثقاً من وجوده، فالغالب مشكلة نطاق لا مشكلة وجود.",
            en: "If the user is certain it exists, it is usually a scope problem, not an existence one.",
        },
    },
    CONFLICT: {
        status: 409,
        messageKey: "errors.conflict",
        cause: {
            ar: "قاعدة عمل تمنع هذه الحالة — انتقال غير مسموح، أو تكرار حيث لا يُسمح.",
            en: "A business rule forbids this state — a disallowed transition, or a duplicate where none is allowed.",
        },
        remedy: {
            ar: "الرسالة تسمّي القاعدة. وإن بدت خاطئة، فهي قرار مكتوب في المخطّط يُراجَع ولا يُلتفّ عليه.",
            en: "The message names the rule. If it looks wrong, it's a written blueprint decision — revise it, don't work around it.",
        },
    },
    VERSION_CONFLICT: {
        status: 409,
        messageKey: "errors.versionConflict",
        cause: {
            ar: "شخصان عدّلا السجل نفسه، والثاني كان يعمل على نسخة أقدم.",
            en: "Two people edited the same record, and the second was on an older copy.",
        },
        remedy: {
            ar: "تحديث الشاشة يعرض آخر نسخة. هذا هو ما يمنع ضياع تعديل أحدهما بصمت.",
            en: "Refreshing shows the latest. This is exactly what stops one person's edit vanishing silently.",
        },
    },
    IDEMPOTENCY_KEY_REUSED: {
        status: 409,
        messageKey: "errors.idempotencyKeyReused",
        cause: {
            ar: "المفتاح نفسه وصل ببيانات مختلفة — إعادة محاولة غير مكتملة أو ضغطة مزدوجة تغيّرت بينهما البيانات.",
            en: "The same key arrived with different data — an incomplete retry, or a double tap with changed data in between.",
        },
        remedy: {
            ar: "الرفض هو الصحيح: البديل هو تنفيذ العملية مرتين.",
            en: "Refusing is correct: the alternative is running the operation twice.",
        },
    },
    // ===== 422 / 429 =====
    /**
     * حدّ المساحة — **ويقول الأرقام الثلاثة**: المشغول والحدّ وحجم الداخل.
     *
     * ففي v2 لم يكن للحدّ تنفيذٌ أصلاً، ثم نزل فحصٌ يرفض برسالةٍ بلا رقم. ومن
     * يُرفض رفعُه يحتاج أن يعرف: أينتظر؟ أيحذف؟ أيطلب زيادة؟ — والأرقام وحدها
     * تجيب.
     */
    STORAGE_QUOTA_EXCEEDED: {
        status: 422,
        messageKey: "errors.storageQuotaExceeded",
        contextKeys: ["usedGb", "quotaGb", "incomingMb"],
        cause: {
            ar: "بلغ العميل حدّ مساحته. الرفع يتوقّف، والقراءة والحذف يظلّان متاحين.",
            en: "The client hit its storage ceiling. Uploads stop; reads and deletes stay available.",
        },
        remedy: {
            ar: "ارفع الحدّ من شاشة العميل، أو احذف ملفات لم تعد لازمة.",
            en: "Raise the quota on the client screen, or delete files no longer needed.",
        },
    },
    /**
     * انتقالٌ غير مسموح في آلة حالة الكارت — **ويسمّي الحالتين**.
     *
     * في v2 كان تغيير الحالة يقبل أي هدفٍ من أي مصدر: لا رسمَ انتقالات ولا رفضاً
     * ولا كوداً. فكان «منجَز ← متوقّف» مقبولاً بلا معنى.
     */
    CARD_TRANSITION_NOT_ALLOWED: {
        status: 409,
        messageKey: "errors.cardTransitionNotAllowed",
        contextKeys: ["from", "to"],
        cause: {
            ar: "آلة حالة البطاقة لا تسمح بهذا الانتقال بعينه — لا لأن صلاحيتك ناقصة.",
            en: "The card's state machine does not allow this particular move — it is not a permission issue.",
        },
        remedy: {
            ar: "الرسالة تسمّي الحالتين. حرّك البطاقة عبر حالةٍ وسيطة، أو حدّث الشاشة إن كانت حالتها تغيّرت.",
            en: "The message names both states. Move the card through an intermediate state, or refresh if its state changed.",
        },
    },
    /**
     * مهلة إعادة الفتح فاتت — **وتقول كم كانت**.
     *
     * وهذه القاعدة لم تكن **موجودةً في كود v2 أصلاً**: لا نافذةَ وقتٍ ولا فحصَ
     * فاعلٍ ولا بوّابةَ دور. كانت مكتوبةً في وثيقةٍ وحدها.
     */
    REOPEN_WINDOW_CLOSED: {
        status: 403,
        messageKey: "errors.reopenWindowClosed",
        contextKeys: ["graceMinutes"],
        cause: {
            ar: "من أنهى البطاقة يُعيد فتحها داخل مهلةٍ قصيرة ليصلح خطأه. وبعدها تصير إعادة الفتح سلطةَ قسمٍ أو شركة.",
            en: "Whoever finished a card may reopen it within a short grace period to fix a mistake. After that, reopening is a department or company authority.",
        },
        remedy: {
            ar: "اطلبها من رئيس قسمك، أو اطلب الصلاحية من زرّ الطلب في شاشة الرفض.",
            en: "Ask your department head, or request the capability from the button on the refusal screen.",
        },
    },
    /**
     * مفتاح الترتيب بلغ حدّ طوله.
     *
     * ولا يقع إلا بسحبٍ متكرّرٍ آلافَ المرّات في نفس الشقّ. ووجودُ كودٍ له هو
     * الفرق بين حدٍّ معلَنٍ وحدٍّ يظهر خمسَ مئة.
     */
    ORDER_KEY_EXHAUSTED: {
        status: 409,
        messageKey: "errors.orderKeyExhausted",
        contextKeys: ["maxLength"],
        cause: {
            ar: "تراكم سحبٌ متكرّر بين نفس الجارَين حتى بلغ مفتاح الترتيب أقصى طوله.",
            en: "Repeated dragging between the same two neighbours grew the ordering key to its maximum length.",
        },
        remedy: {
            ar: "أعد توزيع ترتيب العمود من شاشة اللوحة — عمليةٌ واحدة تُعيد المسافات.",
            en: "Redistribute the column's order from the board screen — one operation restores the spacing.",
        },
    },
    /**
     * العميل مؤرشف — **ومسار الكتابة يرفض، لا يكتب ويسكت**.
     *
     * في v2 كان الحارس المشترك يمنع المحذوف **ولا يمنع المؤرشف**، فالعميل المؤرشف
     * قابلٌ للتعديل بالكامل — هويته وفريقه وكروته وخططه — **وإشعارُ الأرشفة يقول
     * لأعضائه غير ذلك**. إشعارٌ يكذب.
     */
    CLIENT_ARCHIVED: {
        status: 409,
        messageKey: "errors.clientArchived",
        contextKeys: ["client"],
        cause: {
            ar: "العميل مؤرشف: عمله يُقرأ ولا يُعدَّل، وهذا ما أبلغه إشعار الأرشفة لأعضائه.",
            en: "The client is archived: its work is readable but not editable, exactly as the archive notice told its members.",
        },
        remedy: {
            ar: "استعِد العميل من شاشته إن كان العمل عليه مستمرّاً — والاستعادة عمليةٌ معلَنة يسجّلها النظام.",
            en: "Restore the client from its screen if work on it is continuing — restoring is a declared, recorded operation.",
        },
    },
    CLIENT_NOT_ARCHIVED: {
        status: 409,
        messageKey: "errors.clientNotArchived",
        contextKeys: ["client"],
        cause: {
            ar: "هذه العملية تخصّ عميلاً مؤرشفاً، وهذا العميل نشط.",
            en: "This operation is for an archived client, and this one is active.",
        },
        remedy: {
            ar: "أرشِف العميل أولاً إن كان هذا المقصود.",
            en: "Archive the client first if that is what you meant.",
        },
    },
    /**
     * الحذف غير جاهز — **ويقول أيُّ شرطٍ ناقص بعينه**.
     *
     * قرار شادي ٢٠٢٦-٠٩-٢٦: لا يُحذف عميلٌ حتى يُؤرشَف ويكتمل تصديره. فما يمحوه
     * أحدٌ إلا ونسختُه بين يديه.
     */
    CLIENT_DELETE_NOT_READY: {
        status: 409,
        messageKey: "errors.clientDeleteNotReady",
        contextKeys: ["client", "missing"],
        cause: {
            ar: "حذف العميل نهائيٌّ لا رجعة فيه، فيشترط أرشفته واكتمال تصديره أولاً.",
            en: "Deleting a client is irreversible, so it requires the client to be archived and its export to have completed.",
        },
        remedy: {
            ar: "الرسالة تسمّي الناقص: أرشِف العميل، أو شغّل التصدير وانتظر اكتماله.",
            en: "The message names what is missing: archive the client, or run the export and wait for it to finish.",
        },
    },
    /**
     * حذفٌ توقّف — **ولم يقع نصفُه**.
     *
     * الخطوات كلُّها في معاملةٍ واحدة، فالفشل في أيّها يُرجع العميل كما كان كاملاً.
     * وكُتب هنا أوّلاً «ويُستأنف» وفي علاجه «يبدأ من حيث توقّف» — **وكان وعداً لا
     * يصحّ**: التراجع يمحو سجلّ الخطوات معه، فلا يبقى ما يُستأنف منه. وصُحّح في
     * الموديول والوثيقة **وبقي هنا**، في المكان الوحيد الذي يقرؤه المستخدم.
     *
     * وما كان ينقص v2 ليس الاستئناف بل **أن يعرف أحدٌ أين وقف ولماذا**: خمسُ مئةٍ
     * عاريةٌ لكل عميلٍ حقيقي، وترتيبُ المفاتيح هو السبب.
     */
    CLIENT_DELETE_INCOMPLETE: {
        status: 409,
        messageKey: "errors.clientDeleteIncomplete",
        contextKeys: ["client", "step", "detail"],
        cause: {
            ar: "خطوةٌ من خطوات الحذف لم تكتمل، فتوقّف الحذف عندها ولم يمضِ إلى ما بعدها.",
            en: "One step of the deletion did not complete, so the deletion stopped there and did not proceed past it.",
        },
        remedy: {
            ar: "الرسالة تسمّي الخطوة وسببها. العميل رجع كما كان بالكامل — عالِج السبب ثم أعد الحذف من أوّله.",
            en: "The message names the step and its cause. The client was rolled back in full — fix the cause, then run the deletion again from the start.",
        },
    },
    /**
     * نسخةُ العميل لم تجهز للتنزيل — **ولا رابطَ لملفٍّ لم يُكتب**.
     *
     * قرار شادي (٢٠٢٦-١٠-٢٩): الإشعارُ كان يقول «جاهزة للتنزيل» ولا مسارَ يُنزّلها.
     * فالمسارُ نزل، **وطلبُ نسخةٍ لسه بتتجهّز أو فشلت يُرفَض بكودٍ يسمّيه** — لا
     * رابطٌ يفتح ملفاً فارغاً.
     */
    CLIENT_EXPORT_NOT_READY: {
        status: 409,
        messageKey: "errors.clientExportNotReady",
        cause: {
            ar: "النسخة المطلوبة ما زالت قيد التجهيز، أو فشلت وليس لها ملف.",
            en: "The requested export is still being built, or it failed and has no file.",
        },
        remedy: {
            ar: "انتظر إشعار «نسخة العميل جاهزة» ونزّلها بعده — وإن فشلت، فاطلب تصديراً جديداً.",
            en: "Wait for the “client export ready” notice and download it then — if it failed, request a new export.",
        },
    },
    /**
     * تأكيدٌ بكتابة الاسم لم يطابق — **والعربي والإنجليزي كلاهما يُقبَل**.
     *
     * في v2 كان الحارس يقبل **الإنجليزي وحده** في منتجٍ عربيٍّ أولاً، والخلفيةُ
     * تقبل الاثنين: حارسٌ أضيق من خلفيته بلا سبب.
     */
    // ═══════════════════════════ الخطط ودورة الاعتماد ═══════════════════════════
    /**
     * انتقالٌ ليس في الرسم — **ويُقال من أين إلى أين**.
     *
     * وفي v2 كان `changePlanItemState` **يقبل أي هدفٍ من أي مصدر** مثلَ الكروت.
     */
    PLAN_ITEM_TRANSITION_INVALID: {
        status: 409,
        messageKey: "errors.planTransitionInvalid",
        contextKeys: ["from", "to"],
        cause: {
            ar: "عنصر الخطة يمرّ برسمٍ محدَّد، وهذا الانتقال ليس منه.",
            en: "A plan item follows a defined graph, and this transition is not part of it.",
        },
        remedy: {
            ar: "الشاشة تعرض الانتقالات المتاحة من الحالة الحالية — خُذ منها.",
            en: "The screen shows the transitions available from the current state — take one of those.",
        },
    },
    /**
     * تسليمُ مهمةٍ وهي ناقصة — **والرسالة تسمّي الناقص**.
     *
     * وكانت بوابةً على العنصر كلّه، فصارت على كلّ مهمة: معاينةُ مهمة الكفر هي الغلاف.
     */
    PLAN_ITEM_INCOMPLETE: {
        status: 422,
        messageKey: "errors.planItemIncomplete",
        cause: {
            ar: "لا تُسلَّم مهمةٌ وهي بلا معاينةٍ يراها المراجع والعميل.",
            en: "A task is not delivered without a preview the reviewer and the client can see.",
        },
        remedy: {
            ar: "ارفع المعاينة — الرسالة تسمّيها — ثم سلّم.",
            en: "Upload the preview — the message names it — then deliver.",
        },
    },
    /**
     * حركةُ مهمةٍ ليست من رسمها — **ويُقال من أين وبأيّ حركة**.
     *
     * فلا يُعتمَد ما لم يُسلَّم، ولا يُسلَّم المعتمَد.
     */
    PLAN_TASK_MOVE_INVALID: {
        status: 409,
        messageKey: "errors.planTaskMoveInvalid",
        contextKeys: ["from"],
        cause: {
            ar: "المهمة تمرّ برسمٍ محدَّد: تبدأ، ثم تُسلَّم، ثم تُعتمَد أو ترجع.",
            en: "A task follows a defined path: started, delivered, then approved or returned.",
        },
        remedy: {
            ar: "حدّث الشاشة — غالباً حرّك شخصٌ آخر المهمة قبلك.",
            en: "Refresh the screen — most likely someone moved the task before you.",
        },
    },
    /**
     * **لا يراجع أحدٌ شغلَ نفسه** — ولو حمل قدرة المراجعة.
     */
    PLAN_REVIEW_SELF: {
        status: 403,
        messageKey: "errors.planReviewSelf",
        cause: {
            ar: "صاحبُ المهمة لا يبتّ في مراجعتها — فالإنتاج والإجازة سلطتان.",
            en: "A task's owner does not decide its review — producing and clearing it are two authorities.",
        },
        remedy: {
            ar: "اطلب المراجعة من رئيس قسمك أو من يحمل المراجعة على الشركة.",
            en: "Ask your department head, or a company-scope reviewer, to decide it.",
        },
    },
    /**
     * قرارُ عميلٍ على عنصرٍ لا يقبله — **وحالتُه تُقال**.
     */
    PLAN_ITEM_NOT_DECIDABLE: {
        status: 409,
        messageKey: "errors.planItemNotDecidable",
        contextKeys: ["state"],
        cause: {
            ar: "العميل يقرّر على ما أُجيز داخلياً وصار مرئياً له، لا على غيره.",
            en: "A client decides on what has been internally approved and made visible, not on anything else.",
        },
        remedy: {
            ar: "اعتمِد العنصر داخلياً أوّلاً — ورؤيةُ العميل تُفتَح معه تلقائياً.",
            en: "Approve the item internally first — the client's visibility opens with it automatically.",
        },
    },
    /**
     * تعديلُ ما نُشر — **يُرفَض، لا يُسكَت عنه**.
     *
     * فبايتاتٌ على منصّةٍ حقيقية لا يُغيَّر ما يقابلها في النظام وحده.
     */
    PLAN_ITEM_PUBLISHED_EDIT_REFUSED: {
        status: 409,
        messageKey: "errors.planPublishedEditRefused",
        contextKeys: ["state"],
        cause: {
            ar: "العنصر منشورٌ أو منتهٍ، وتعديل حقلٍ يراه العميل يجعل ما في النظام مخالفاً لما على المنصّة.",
            en: "The item is published or closed, and editing a client-facing field would make the system disagree with what is live.",
        },
        remedy: {
            ar: "اسحب الاعتماد أوّلاً — فيُنبَّه من ينزل المنشور، ثم عدّل.",
            en: "Withdraw the approval first — whoever must take the live post down is alerted — then edit.",
        },
    },
    /** عنصرٌ بلا مسنَدٍ واحد — ممنوع عند الإنشاء وعند السحب. */
    PLAN_ITEM_LAST_ASSIGNEE: {
        status: 409,
        messageKey: "errors.planLastAssignee",
        cause: {
            ar: "لا يبقى عنصرٌ بلا مهمة — فعملٌ بلا صاحبٍ لا يُنجَز.",
            en: "No item is left without a task — work with no owner does not get done.",
        },
        remedy: {
            ar: "أضِف المهمة الجديدة أوّلاً ثم احذف هذه.",
            en: "Add the new task first, then remove this one.",
        },
    },
    /**
     * مرشَّحٌ لا يصلح للإسناد — **ويُقال أيُّ شرطٍ سقط**.
     */
    PLAN_ASSIGNEE_NOT_ELIGIBLE: {
        status: 422,
        messageKey: "errors.planAssigneeNotEligible",
        contextKeys: ["user", "reason"],
        cause: {
            ar: "المسنَد إليه يجب أن يكون في فريق العميل، نشطاً، وقسمُه معلَّمٌ بأنه يُسنَد إليه عمل خطة.",
            en: "An assignee must be on the client's team, active, and in a department marked as taking plan work.",
        },
        remedy: {
            ar: "أدخِله فريقَ العميل، أو علِّم قسمه بأنه يُسنَد إليه عمل خطة من شاشة الأقسام.",
            en: "Add them to the client's team, or mark their department as taking plan work in the departments screen.",
        },
    },
    /** استثناءٌ معلّقٌ على العنصر — **واحدٌ في المرّة**. */
    PLAN_EXCEPTION_PENDING: {
        status: 409,
        messageKey: "errors.planExceptionPending",
        cause: {
            ar: "هذا العنصر وقف على استثناءِ مراجعةٍ لم تبتّ فيه الإدارة بعد.",
            en: "This item is parked on a revision exception that administration has not decided yet.",
        },
        remedy: {
            ar: "ابتّ في الاستثناء القائم أوّلاً — شاشة الخطط تعرضه على العنصر.",
            en: "Decide the open exception first — the plans screen shows it on the item.",
        },
    },
    /** إلغاءٌ من حالةٍ لا تُلغى. */
    PLAN_ITEM_CANCEL_INVALID_STATE: {
        status: 409,
        messageKey: "errors.planCancelInvalidState",
        contextKeys: ["state"],
        cause: {
            ar: "ما نُشر أو انتهى لا يُلغى — فالإلغاء يمحو عملاً لم يخرج بعد.",
            en: "What has been published or closed is not cancelled — cancelling removes work that has not gone out yet.",
        },
        remedy: {
            ar: "اسحب الاعتماد ثم ألغِ، أو اترك العنصر كما هو إن كان قد خرج فعلاً.",
            en: "Withdraw the approval then cancel, or leave the item as it is if it has genuinely gone out.",
        },
    },
    /** خطةٌ بنفس الاسم والفترة للعميل نفسه. */
    PLAN_NAME_DUPLICATE: {
        status: 409,
        messageKey: "errors.planNameDuplicate",
        contextKeys: ["name"],
        cause: {
            ar: "للعميل خطةٌ بنفس الاسم ونفس نوع الفترة.",
            en: "The client already has a plan with the same name and period type.",
        },
        remedy: {
            ar: "غيّر الاسم أو نوع الفترة — والشهر في الاسم يكفي للتفريق.",
            en: "Change the name or the period type — putting the month in the name is enough to tell them apart.",
        },
    },
    /** مدى خطةٍ غير صالح — يومان فأكثر. */
    PLAN_DATE_RANGE_INVALID: {
        status: 422,
        messageKey: "errors.planDateRangeInvalid",
        cause: {
            ar: "نهاية الخطة يجب أن تكون بعد بدايتها — فخطّةُ يومٍ واحدٍ ليست خطّة.",
            en: "A plan's end must fall after its start — a single-day plan is not a plan.",
        },
        remedy: {
            ar: "اضبط التاريخين فيكون الفارق يوماً على الأقل.",
            en: "Set the two dates so there is at least a day between them.",
        },
    },
    /** طلبُ تعديلٍ على عنصرٍ لم يوافق عليه العميل بعد. */
    PLAN_ITEM_NOT_EDIT_REQUESTABLE: {
        status: 409,
        messageKey: "errors.planNotEditRequestable",
        contextKeys: ["state"],
        cause: {
            ar: "طلبُ التعديل بعد الموافقة — فما لم يُوافَق عليه يُعدَّل مباشرةً.",
            en: "An edit request comes after approval — what has not been approved is simply edited.",
        },
        remedy: {
            ar: "عدّل العنصر مباشرةً، فلا موافقةَ تُسحَب.",
            en: "Edit the item directly; there is no approval to withdraw.",
        },
    },
    /** سحبُ اعتمادٍ مسحوبٍ بالفعل. */
    PLAN_ITEM_ALREADY_WITHDRAWN: {
        status: 409,
        messageKey: "errors.planAlreadyWithdrawn",
        cause: {
            ar: "العنصر رجع إلى التنفيذ بالفعل، فلا اعتمادَ قائمٌ يُسحَب.",
            en: "The item is already back in production, so there is no standing approval to withdraw.",
        },
        remedy: {
            ar: "حدّث الشاشة — الحالة تغيّرت قبل ضغطتك.",
            en: "Refresh the screen — the state changed before your click.",
        },
    },
    /** وسيطٌ بلا مصدرٍ أو بمصدرين. */
    PLAN_MEDIA_SOURCE_INVALID: {
        status: 422,
        messageKey: "errors.planMediaSourceInvalid",
        cause: {
            ar: "الوسيط إمّا ملفٌّ مرفوع وإمّا رابطٌ خارجي — لا الاثنان ولا لا شيء.",
            en: "A media entry is either an uploaded file or an external link — not both, and not neither.",
        },
        remedy: {
            ar: "ارفع ملفاً أو الصق رابطاً، واحداً منهما.",
            en: "Upload a file or paste a link — one of the two.",
        },
    },
    CONFIRMATION_NAME_MISMATCH: {
        status: 422,
        messageKey: "errors.confirmationNameMismatch",
        contextKeys: ["expected"],
        cause: {
            ar: "الفعل هدّامٌ لا رجعة فيه، فيُطلب كتابة اسم ما يُحذف بالحرف — بالعربية أو بالإنجليزية.",
            en: "The action is irreversible, so it asks you to type the name of what is being deleted — in Arabic or in English.",
        },
        remedy: {
            ar: "انسخ الاسم كما تعرضه الشاشة. اختلافُ لغةٍ لا يمنع، واختلافُ حرفٍ يمنع.",
            en: "Copy the name as the screen shows it. A different language is fine; a different letter is not.",
        },
    },
    DUE_CHANGE_ALREADY_PENDING: {
        status: 409,
        messageKey: "errors.dueChangeAlreadyPending",
        contextKeys: ["requestedBy"],
        cause: {
            ar: "للبطاقة طلبُ تغيير موعدٍ معلَّق بالفعل — وطلبٌ واحدٌ لكل بطاقة.",
            en: "The card already has a pending due-change request — one per card.",
        },
        remedy: {
            ar: "انتظر الردّ عليه، أو اسحبه واطلب غيره — طلب واحد مفتوح فقط لكل بطاقة.",
            en: "Wait for it to be decided, or withdraw it and request another — one open request per card.",
        },
    },
    DUE_CHANGE_ALREADY_RESOLVED: {
        status: 409,
        messageKey: "errors.dueChangeAlreadyResolved",
        contextKeys: ["decidedBy"],
        cause: {
            ar: "يبتّ في الطلب رئيسُ القسم أو مديرُ حساب العميل، وأوّلُ من يبتّ يقفله. وقد بُتّ فيه.",
            en: "The request is decided by the department head or the client's account manager, and whoever decides first closes it. It has been decided.",
        },
        remedy: {
            ar: "حدّث الشاشة لترى القرار ومن اتّخذه. لا شيء ضاع.",
            en: "Refresh to see the decision and who made it. Nothing was lost.",
        },
    },
    BOARD_LAST_COLUMN: {
        status: 422,
        messageKey: "errors.boardLastColumn",
        cause: {
            ar: "اللوحة بلا أعمدة لا تعرض شيئاً ولا تستقبل بطاقة — فلا تُترَك بصفر أعمدة.",
            en: "A board with no columns shows nothing and accepts no card — so it is never left with zero.",
        },
        remedy: {
            ar: "أضف عموداً بديلاً قبل حذف الأخير، أو أرشِف اللوحة كلّها إن كانت انتهت.",
            en: "Add a replacement column before deleting the last one, or archive the whole board if it is finished.",
        },
    },
    COLUMN_DELETE_NEEDS_TARGET: {
        status: 422,
        messageKey: "errors.columnDeleteNeedsTarget",
        contextKeys: ["cardCount"],
        cause: {
            ar: "في العمود بطاقاتٌ — والمؤرشفة منها تُحتسب. وحذفه بلا بديلٍ يترك بطاقاتٍ بلا موضع.",
            en: "The column holds cards — archived ones count too. Deleting it without a target would leave cards with no location.",
        },
        remedy: {
            ar: "اختر العمود الذي تنتقل إليه بطاقاته. الرسالة تقول عددها.",
            en: "Choose the column its cards move to. The message says how many.",
        },
    },
    /**
     * إشارةُ قسمٍ لا صلة له بالسجل.
     *
     * في v2 كان فحصُ الصلة في الكروت **وغائباً في المهام المباشرة**: فمن يعلّق
     * على مهمّةٍ واحدة يُشعِر كشفَ أي قسمٍ كاملاً في الشركة.
     */
    MENTION_NOT_RELEVANT: {
        status: 422,
        messageKey: "errors.mentionNotRelevant",
        contextKeys: ["department"],
        cause: {
            ar: "الإشارة تُشعِر كشف القسم كلَّه، فتقتصر على قسمٍ له صلةٌ معلَنة بهذا العمل.",
            en: "A department mention notifies its whole roster, so it is limited to a department with a declared connection to this work.",
        },
        remedy: {
            ar: "الرسالة تسمّي القسم. أشِر إلى الأشخاص بأسمائهم، أو أضف القسم إلى فريق العميل إن كان معنيّاً فعلاً.",
            en: "The message names the department. Mention people by name, or add the department to the client's team if it really is involved.",
        },
    },
    /**
     * قيدُ قاعدة بيانات — **مُترجَم، لا خمسُ مئة**.
     *
     * في v2 كان حذفُ قالب بوردٍ بمعرّفٍ غير موجود يرفع خمسَ مئة، **ويفتح حادثةً
     * حرجة في صحة النظام**، لأن المرشّح العامّ لا يعرف أخطاء قاعدة البيانات.
     * فمستخدمٌ ينقر «حذف» مرّتين **يصنع حادثة إنتاجٍ كاذبة**. وكان المشروع كلّه
     * بلا ترجمةٍ واحدة لأخطاء المفاتيح الأجنبية.
     *
     * **ولا `incident` هنا**: هذه نتيجةُ عملٍ طبيعية، لا عطلٌ في النظام.
     */
    /**
     * **قيمةٌ مستعملةٌ بالفعل** — والقيدُ في القاعدة هو من قالها.
     *
     * وكان خرقُ أيّ فهرسٍ فريد يخرج `500` بلا رسالة: فحصٌ في الكود يسبق الكتابة
     * **لا يكفي** — طلبان متزامنان يقرآن «غيرُ مستعمل» فيكتبان، والثاني يُردّ من
     * القاعدة لا من الفحص. وكان `DATABASE_CONSTRAINT` وحده، **ونصُّه مكتوبٌ
     * للمفتاح الأجنبيّ** («فيه حاجة تانية معتمدة عليه — امسحها الأول») — وهو
     * جوابٌ خاطئٌ تماماً لمن كتب إيميلاً مستعملاً.
     */
    UNIQUE_VALUE_TAKEN: {
        status: 409,
        messageKey: "errors.uniqueValueTaken",
        contextKeys: ["entity", "constraint"],
        cause: {
            ar: "القيمة مستعملة بالفعل في سجلّ آخر — إمّا كتبها اثنان في نفس اللحظة، وإمّا الفحص قبل الكتابة لم يرَها.",
            en: "The value is already used by another record — either two people wrote it at once, or the pre-write check did not see it.",
        },
        remedy: {
            ar: "غيّر القيمة وجرّب مرة أخرى. والرسالة تسمّي الكيان والقيد — فإن كان القيد لا يصف ما كتبه المستخدم، فالفحص قبل الكتابة ناقص.",
            en: "Change the value and try again. The message names the entity and the constraint — if the constraint does not describe what the user typed, the pre-write check is missing.",
        },
    },
    DATABASE_CONSTRAINT: {
        status: 409,
        messageKey: "errors.databaseConstraint",
        contextKeys: ["entity", "constraint"],
        cause: {
            ar: "قاعدة البيانات رفضت الكتابة لأن سجلاً آخر يعتمد عليها، أو لأن القيمة مستعملة بالفعل.",
            en: "The database refused the write because another record depends on it, or the value is already taken.",
        },
        remedy: {
            ar: "الرسالة تسمّي الكيان والقيد. غالباً المطلوب حذفُ ما يعتمد عليه أولاً، أو تغييرُ القيمة المكرّرة.",
            en: "The message names the entity and the constraint. Usually you need to remove what depends on it first, or change the duplicate value.",
        },
    },
    /**
     * رفضُ الملف — **أربعة أكواد لا كود واحد**.
     *
     * كان كوداً واحداً برسالة «الملف اترفض — يا إما نوعه مش مسموح، يا إما الفحص
     * لقى فيه مشكلة». وهذه هي الرسالة العامة بعينها: تصف احتمالات، ولا تقول
     * للواقف أمام الشاشة **أيُّها وقع له**. فصاحب الملف لا يعرف: أيغيّر النوع؟
     * أيصغّر الحجم؟ أينتظر؟ أم أن في جهازه فيروساً؟ أربعة أفعال مختلفة تماماً.
     */
    FILE_TYPE_NOT_ALLOWED: {
        status: 422,
        messageKey: "errors.fileTypeNotAllowed",
        contextKeys: ["contentType"],
        cause: {
            ar: "نوع الملف ليس في قائمة الأنواع المسموح برفعها.",
            en: "The file's type is not on the allow-list.",
        },
        remedy: {
            ar: "الرسالة تذكر النوع المرفوض بالاسم. القائمة في إعدادات المرفقات.",
            en: "The message names the rejected type. The allow-list lives in attachment settings.",
        },
    },
    FILE_TOO_LARGE: {
        status: 413,
        messageKey: "errors.fileTooLarge",
        contextKeys: ["sizeMb", "limitMb"],
        cause: {
            ar: "حجم الملف أكبر من الحدّ المسموح.",
            en: "The file is larger than the limit.",
        },
        remedy: {
            ar: "الرسالة تذكر حجمه وحدّنا بالأرقام — والرفض يصل قبل أن يبدأ الرفع، لا بعده.",
            en: "The message states both its size and our limit — and the refusal arrives before the upload starts, not after.",
        },
    },
    FILE_SCAN_PENDING: {
        status: 409,
        messageKey: "errors.fileScanPending",
        cause: {
            ar: "الملف رُفع ولم يكتمل فحصه بعد، فلا يُتاح تنزيله.",
            en: "The file is uploaded but not yet scanned, so it cannot be downloaded.",
        },
        remedy: {
            ar: "ثوانٍ عادةً. وإن طال: طابور الفحص في شاشة صحة النظام — فاحصٌ متوقّف يظهر هناك.",
            en: "Usually seconds. If it persists, the scan queue is on System Health — a stopped scanner shows there.",
        },
    },
    FILE_INFECTED: {
        status: 422,
        messageKey: "errors.fileInfected",
        contextKeys: ["signature"],
        cause: {
            ar: "فحص الملفات وجد برمجية خبيثة في الملف، فرُفض ومُسحت بايتاته.",
            en: "The scanner found malware in the file, so it was rejected and its bytes deleted.",
        },
        remedy: {
            ar: "اسم ما وجده الفاحص في الرسالة. الملف لم يعد موجوداً — والحادثة مرفوعة للإدارة.",
            en: "The scanner's finding is named in the message. The file is gone — and an incident is raised to administration.",
        },
    },
    /**
     * مدّة استثناءٍ أطول من الحدّ.
     *
     * وله كودٌ خاص لأن «غير صالح» لا يقول لصاحبه إن المشكلة في **الطول** وحده —
     * فيظنّ التاريخ خطأً ويجرّب تواريخ أخرى بالطول نفسه.
     */
    OVERRIDE_TOO_LONG: {
        status: 422,
        messageKey: "errors.overrideTooLong",
        contextKeys: ["maxDays", "requestedDays"],
        cause: {
            ar: "الاستثناء الفردي مؤقّت بقرار، وهذه المدّة تتجاوز الحدّ.",
            en: "An individual override is temporary by decision, and this period exceeds the limit.",
        },
        remedy: {
            ar: "قصّر المدّة، أو — إن كان المطلوب دائماً — غيّر الدور نفسه بدل الاستثناء عليه.",
            en: "Shorten it, or — if it is meant to be permanent — change the role itself instead of overriding it.",
        },
    },
    /**
     * وجهة النسخ الاحتياطي لا تعمل.
     *
     * ولها كودٌ خاص لأنها تقع **لحظة الإعداد الأول**، والمشتري وحده أمام الشاشة.
     * «تعذّر الاتصال» تتركه يخمّن: أالعنوان؟ أالمفتاح؟ أالدلو غير موجود؟
     */
    BACKUP_DESTINATION_UNUSABLE: {
        status: 422,
        messageKey: "errors.backupUnusable",
        contextKeys: ["bucket", "detail"],
        cause: {
            ar: "التخزين البعيد رفض الكتابة أو القراءة أو المسح بالبيانات المُدخَلة.",
            en: "The remote storage refused to write, read, or delete with the details given.",
        },
        remedy: {
            ar: "الرسالة تحمل ردّ التخزين نفسه. راجع العنوان والمفتاح واسم الدلو وصلاحية الكتابة فيه.",
            en: "The message carries the storage's own reply. Check the endpoint, key, bucket name, and write permission.",
        },
    },
    /**
     * **جلسةٌ بورتالية على عمليةٍ غير معلَّمة آمنةً لها.**
     *
     * وهذا كودُ الحدّ نفسه، لا كودُ قدرةٍ ناقصة: يُرفَض **قبل** أن يُسأل عن
     * القدرة، فلا يحتاج التسريبُ قدرةً ليقع ولا يمنعه غيابُ قدرة.
     *
     * وفي v2 كان الحدُّ خاصيّةً ناشئة عن ثمانيةَ عشرَ فحصاً مستقلاً، **وفحصٌ واحد
     * ناقص كفى للتسريب**: جهةُ اتصالٍ تنادي المسار العامّ بمعرّفٍ أخذته من مسارٍ
     * بورتاليّ آمن، فيعود إليها اسمُ كل موظفٍ كتب رسالة وصورتُه. وبلوغُ هذا
     * الكودِ اليومَ يعني أن الحدَّ عمل.
     */
    PORTAL_OPERATION_REFUSED: {
        status: 403,
        messageKey: "errors.portalOperationRefused",
        /**
         * **ولا قيمةَ في نصّه** — فاسمُ العملية شأنُ السجلّ لا شأنُ العميل.
         *
         * ويبقى في `context` ليقرأه من يحقّق، **ولا يُحشَر في رسالةٍ** تقول لجهة
         * اتصالٍ `plans.items.read` — وهي كلمةٌ لا تعني لها شيئاً.
         */
        cause: {
            ar: "هذه العملية للاستعمال الداخلي: لم تُعلَن آمنةً لجلسة من بوابة العميل، فالافتراض فيها المنع.",
            en: "This operation is internal: it is not declared portal-safe, and the default for that is refusal.",
        },
        remedy: {
            ar: "لا شيء يُفعَل من بوابة العميل. فإن كان العميل محتاجاً هذا فعلاً، فهو ميزةٌ تُعلَن في شجرة بوابة العميل أوّلاً — لا استثناءٌ يُضاف في الكود.",
            en: "Nothing to do from the portal. If a client genuinely needs this, it is a feature declared in the portal sub-tree first — not an exception added in code.",
        },
    },
    /**
     * **بورتالُ هذا العميل مطفأ** — فقدراتُه مسحوبةٌ من موضعٍ واحد.
     *
     * ولا زرَّ ثانياً يُنسى: النطاقُ يُشتقّ من **عميلٍ بورتالُه مفعَّل**، فإطفاؤه
     * يسحب كلَّ قدرةٍ عليه في الحساب التالي.
     */
    PORTAL_DISABLED: {
        status: 409,
        messageKey: "errors.portalDisabled",
        cause: {
            ar: "بوابة هذا العميل غير مفعَّلة — إمّا لم يُفعَّل بعد، أو أُطفئ.",
            en: "This client's portal is not enabled — either not yet turned on, or turned off.",
        },
        remedy: {
            ar: "مديرُ الحساب يفعّله من ملفّ العميل. وحتى يُفعَّل، لا جهةَ اتصالٍ تصل إلى شيء.",
            en: "The account manager enables it from the client's profile. Until then no contact reaches anything.",
        },
    },
    /**
     * **مفاتيحُ إشعار الدفع غير مضبوطة** — ولا يُسكَت على ذلك.
     *
     * فتطبيقٌ مثبَّت لا يُنبِّه هو موقعٌ بأيقونة. ولو كان الاشتراك يُحفَظ ثم لا
     * يصل شيء، لصار العطبُ صامتاً — وهذا هو ما نبني ضدّه.
     */
    PUSH_NOT_CONFIGURED: {
        status: 409,
        messageKey: "errors.pushNotConfigured",
        cause: {
            ar: "مفتاح إشعارات الدفع العامّ غير مضبوط في الإعدادات، أو سرُّه غائب عن بيئة التشغيل.",
            en: "The public push key is not set in settings, or its secret is missing from the runtime environment.",
        },
        remedy: {
            ar: "اضبط المفتاح العامّ من شاشة الإعدادات، وضع السرّ في بيئة التشغيل. والسرُّ لا يُخزَّن في جدولٍ يُقرأ من شاشة.",
            en: "Set the public key from the settings screen and put the secret in the runtime environment. The secret is never stored in a table read from a screen.",
        },
    },
    /**
     * **وجهةُ النسخ غيرُ مضبوطة** — لا يقف بها النظام، ولا يُسكَت عنها: صفٌّ أحمر بكوده.
     */
    /**
     * **عنوانٌ لا تملكه وكالة** — ومع أكثر من وكالةٍ لا يسقط على أيٍّ منها.
     */
    /** **عطلٌ على جهاز المستخدم** — وصلنا منه، بمرجعه الذي يراه هو */
    BROWSER_FAULT: {
        status: 500,
        messageKey: "errors.internal",
        cause: {
            ar: "خطأ في الواجهة على جهاز المستخدم: انكسرت شاشة أو رُفض وعدٌ بلا معالجة.",
            en: "A fault in the interface on the user's device: a screen broke or a promise was rejected unhandled.",
        },
        remedy: {
            ar: "افتح الحادثة برقم المرجع — فيها الشاشة ومكان الخطأ في الكود.",
            en: "Open the incident by its reference — it names the screen and the place in the code.",
        },
        incident: true,
    },
    /** **زرٌّ ظهر والسيرفرُ رفضه** — فالزرُّ يكذب: وهو ما صدم شادي في Planner */
    BUTTON_REFUSED: {
        /** **لا يخرج على السلك** — صفُّ حادثة، والمستخدمُ رأى رفضَ العملية نفسها بكوده */
        status: 500,
        messageKey: "errors.internal",
        cause: {
            ar: "ظهر للموظف زرٌّ والسيرفر رفض العملية: ما تعرضه الشاشة يخالف صلاحياته.",
            en: "A button was shown and the server refused the action: the screen disagrees with the permissions.",
        },
        remedy: {
            ar: "راجع العملية في الحادثة: إمّا أن يُخفى الزرُّ لهذا الدور، وإمّا أن ينقصه صلاحية.",
            en: "Check the operation in the incident: either hide the button for this role, or the role lacks a permission.",
        },
        incident: true,
    },
    /** **كان سيعمل، ووقف قبل أثرٍ حقيقيّ** — ملفٌّ يُرفع أو تنبيهٌ يصل هاتفاً */
    PREVIEW_STOPPED: {
        status: 409,
        messageKey: "errors.previewStopped",
        cause: {
            ar: "أنت في وضع «بعين الموظف»، وهذه العملية لها أثرٌ خارج قاعدة البيانات فلا تُلغيها المعاملة.",
            en: "You are viewing as an employee, and this action has an effect outside the database that a rollback cannot undo.",
        },
        remedy: {
            ar: "وصولُها إلى هنا يعني أن صلاحياته تسمح بها. اخرج من الوضع لتنفيذها بنفسك.",
            en: "Reaching this point means their permissions allow it. Leave the mode to do it yourself.",
        },
    },
    /** **المحادثاتُ الخاصة مقفولة في وضع «بعين الموظف»** */
    PREVIEW_PRIVATE: {
        status: 403,
        messageKey: "errors.previewPrivate",
        cause: {
            ar: "محادثاتُ الموظف الخاصة لا تُفتح في وضع «بعين الموظف»، حتى للمالك.",
            en: "An employee's private chats do not open in view-as mode, even for the owner.",
        },
        remedy: {
            ar: "اسأل الموظف عن المشكلة فيها، أو اطلب منه رقم الخطأ.",
            en: "Ask the employee about the problem there, or ask for the error reference.",
        },
    },
    WORK_ARCHIVED: {
        status: 409,
        messageKey: "errors.workArchived",
        cause: {
            ar: "هذا الشغل في الأرشيف: يُقرأ ولا يُعدَّل.",
            en: "This work is in the archive: it can be read but not changed.",
        },
        remedy: {
            ar: "افتح خطةً أو مهمةً جديدة لما تريد إكماله.",
            en: "Open a new plan or task for whatever should continue.",
        },
    },
    TENANT_UNKNOWN: {
        status: 404,
        messageKey: "errors.tenantUnknown",
        cause: {
            ar: "وصل الطلبُ على عنوانٍ غيرِ مربوطٍ بأيّ وكالة.",
            en: "The request reached an address that no agency is linked to.",
        },
        remedy: {
            ar: "اربط العنوانَ بوكالته بأمر الوكالات، أو صحّح رابطَ الدخول.",
            en: "Link the address to its agency with the tenant command, or correct the sign-in link.",
        },
    },
    BACKUP_NOT_CONFIGURED: {
        status: 409,
        messageKey: "errors.backupNotConfigured",
        cause: {
            ar: "عنوانُ وجهة النسخ أو دلوها غائبٌ من الإعدادات، أو مفتاحاها غائبان من بيئة التشغيل.",
            en: "The backup endpoint or bucket is missing from settings, or its keys are missing from the runtime environment.",
        },
        remedy: {
            ar: "اضبط العنوانَ والدلو من الإعدادات، وضع BACKUP_KEY وBACKUP_SECRET في بيئة التشغيل.",
            en: "Set the endpoint and bucket in settings, and put BACKUP_KEY and BACKUP_SECRET in the runtime environment.",
        },
    },
    /**
     * **دورةُ نسخٍ سقطت** — وآخرُ نسخةٍ تكبر في العمر حتى تُصلَح.
     *
     * وفي المجاور كُتبت نسخٌ فارغةٌ إحدى عشرة ليلةً بلا أن يلاحظ أحد، فالسقوطُ حادثةٌ وإشعار.
     */
    BACKUP_FAILED: {
        status: 502,
        messageKey: "errors.backupFailed",
        cause: {
            ar: "تعذّر أخذُ النسخة أو رفعُها إلى الوجهة أو التحقّقُ منها. وسببُها بنصّه في الحادثة.",
            en: "Taking the backup, uploading it, or verifying it failed. The exact reason is in the incident.",
        },
        remedy: {
            ar: "اقرأ السببَ في «صحة النظام»، وتأكّد من صلاحية مفتاحَي الوجهة. والدورةُ تُعاد كلَّ ساعة وحدها.",
            en: "Read the reason in System health and check the destination keys. The cycle retries every hour by itself.",
        },
    },
    /**
     * **تنبيهُ تجربةٍ لم يصل جهازاً واحداً** — والأجهزةُ مفعّلةٌ والمفاتيحُ مضبوطة.
     *
     * فـ«أُرسل» على لا شيء رسالةٌ تكذب: صاحبُها ينتظر تنبيهاً لن يأتي ويظنّ العطبَ
     * في هاتفه. **والسببُ في السجلّ بمعرّف الطلب**.
     */
    PUSH_DELIVERY_FAILED: {
        status: 502,
        messageKey: "errors.pushDeliveryFailed",
        cause: {
            ar: "خدمةُ التنبيهات رفضت الإرسال إلى كل الأجهزة المفعّلة، أو لم تُجِب.",
            en: "The push service refused or did not answer for every enabled device.",
        },
        remedy: {
            ar: "أعِد المحاولة بعد دقيقة. وإن تكرّر، فأوقِف التنبيه على الجهاز وفعّله من جديد.",
            en: "Try again in a minute. If it repeats, turn notifications off on the device and on again.",
        },
    },
    /**
     * **تقريرٌ واحدٌ لكل عميلٍ في الشهر** (قرار شادي) — والثاني يطلب استثناءً.
     *
     * والحدُّ يحمي العميلَ من الإغراق بتقاريرَ نصفِ محضَّرة، **والاستثناءُ يفتح
     * بابَ الحالة الحقيقية**: حملةٌ خاصة، أو تقريرٌ تصحيحيّ.
     */
    /**
     * **ومقياسٌ لا معنى له عند هذا المستوى يُرفَض** — لا يُجاب برقمٍ يبدو صحيحاً.
     *
     * فـ«نزل في موعده» ليس له معنًى لشخص: النشرةُ تخصّ عنصراً، ومن وسمها موظّفُ
     * وساطةٍ لا صاحبُ العنصر. **ورقمٌ يُجاب به سؤالٌ خطأ أسوأُ من رفض** — يُقرأ
     * ويُبنى عليه.
     */
    /**
     * **قناةٌ لا تبلغه** — ولا تُقال «غير موجودة».
     *
     * فـ«غير موجودة» تخفي الوجود، **و«لا تبلغك» تقول الحقيقة**: القناةُ موجودةٌ
     * ولستَ فيها. وفي محادثةٍ بين موظّفين لا سرَّ في وجودها، **والإخفاءُ يجعل من
     * فتح رابطاً قديماً يظنّ أن الكلامَ ضاع**.
     */
    CHAT_CHANNEL_NOT_REACHABLE: {
        status: 403,
        messageKey: "errors.chatChannelNotReachable",
        cause: {
            ar: "القناة ليست من نوع يبلغه بقدراته، أو ليس عضواً فيها — والمجموعة والمحادثة وصولُهما العضوية.",
            en: "The channel is not a kind their capabilities reach, or they are not a member — groups and direct conversations are reached by membership.",
        },
        remedy: {
            ar: "مجموعةٌ يُضَمّ إليها صاحبُها، ومحادثةٌ تُفتَح بين طرفيها. وقناةُ العميل الداخلية تحتاج عضويةً في فريقه.",
            en: "A group needs the person added to it, a direct conversation is between its two sides, and a client's internal channel needs membership of that client's team.",
        },
    },
    CHAT_MESSAGE_NOT_YOURS: {
        status: 403,
        messageKey: "errors.chatMessageNotYours",
        cause: {
            ar: "محاولة تعديل أو مسح رسالة شخص آخر بقدرة «تعديل رسالتي».",
            en: "An attempt to edit or delete someone else's message with the own-message capability.",
        },
        remedy: {
            ar: "مسحُ رسالة غيره يحتاج قدرة الإشراف — والمسح يبقي أثره في الحالتين.",
            en: "Deleting another person's message needs the moderation capability — and either way the deletion leaves its trace.",
        },
    },
    CHAT_MESSAGE_GONE: {
        status: 409,
        messageKey: "errors.chatMessageGone",
        cause: {
            ar: "الرسالة ممسوحة بالفعل — وسطرُها باقٍ لأن النقاش يبقى مفهوماً.",
            en: "The message is already deleted — its line remains so the thread still reads.",
        },
        remedy: {
            ar: "لا شيء يُفعَل: الممسوح لا يُعدَّل ولا يُمسَح ثانيةً.",
            en: "Nothing to do: a deleted message is neither edited nor deleted again.",
        },
    },
    CHAT_REPLY_TARGET_INVALID: {
        status: 422,
        messageKey: "errors.chatReplyTargetInvalid",
        cause: {
            ar: "الرسالةُ المردودُ عليها ليست في هذه القناة، أو حُذفت.",
            en: "The message being replied to is not in this channel, or was deleted.",
        },
        remedy: {
            ar: "اكتب الردَّ كرسالةٍ عادية، أو رُدّ على رسالةٍ قائمةٍ هنا.",
            en: "Send it as a normal message, or reply to a message that still exists here.",
        },
    },
    CHAT_REACTION_INVALID: {
        status: 422,
        messageKey: "errors.chatReactionInvalid",
        cause: {
            ar: "التفاعلُ إيموجي واحد — وما وصل كان كلاماً أو فارغاً.",
            en: "A reaction is a single emoji — what arrived was text or empty.",
        },
        remedy: {
            ar: "اختر إيموجي من المكتبة.",
            en: "Pick an emoji from the picker.",
        },
    },
    CHAT_DIRECT_WITH_SELF: {
        status: 422,
        messageKey: "errors.chatDirectWithSelf",
        cause: {
            ar: "طلب محادثة ثنائية والطرفان شخص واحد.",
            en: "A direct conversation was requested with both sides being the same person.",
        },
        remedy: {
            ar: "اختر زميلاً. ولو كان المطلوب مذكّرةً لنفسه فمكانها «أعمالي» لا المحادثات.",
            en: "Pick a colleague. A note to self belongs in My Work, not in chat.",
        },
    },
    CHAT_PORTAL_CHANNEL_ONLY: {
        status: 409,
        messageKey: "errors.chatPortalChannelOnly",
        cause: {
            ar: "استُعمل مسارُ الردّ على العميل في قناةٍ ليست قناةَ عميل.",
            en: "The client-reply route was used on a channel that is not a client's channel.",
        },
        remedy: {
            ar: "الكتابة في القنوات الداخلية بمسارها هي، وبقدرة «الكتابة في المحادثات».",
            en: "Writing in internal channels goes through its own route, with the write-in-chat capability.",
        },
    },
    /**
     * **ولا يقبل طرفٌ اقتراحَه هو** (§3 منذ البداية).
     *
     * فمن اقترح موعداً وقَبِله بنفسه **جعل الاقتراحَ تأكيداً**، والطرفُ الآخر يجد
     * موعداً لم يوافق عليه — ثم لا يحضره أحد. **والفحصُ على جهة الاقتراح** لا على
     * هوية الفاعل: فقد يقترح مديرُ الحساب ويقبل زميلُه، وذلك مقبولٌ — الوكالةُ
     * طرفٌ واحد. ولو قيس بالهوية **لمرَّ زميلٌ يقبل اقتراح زميله**.
     */
    /**
     * **ولا يُنشَر إصدارٌ من حالةٍ لا تسمح** — ولا يُعدَّل منشور.
     *
     * **فمن قرأ «الجديد» أمسِ قرأ غيرَ ما يُقرأ اليوم**: نصٌّ يُعدَّل بعد نشره
     * يجعل نصفَ الفريق يعرف شيئاً والنصفَ الآخر غيرَه، **ولا أحدَ يعرف أنهما
     * اختلفا**. والتصحيحُ إصدارٌ جديدٌ برقمه.
     */
    RELEASE_STATE_INVALID: {
        status: 409,
        messageKey: "errors.releaseStateInvalid",
        contextKeys: ["state"],
        cause: {
            ar: "الفعل المطلوب لا يصحّ على حالة الإصدار — كنشر مسودّة بلا مراجعة، أو تعديل منشور.",
            en: "The action does not apply to the release's state — publishing an unreviewed draft, or editing a published one.",
        },
        remedy: {
            ar: "المسودّة تُرسَل للمراجعة أولاً، والمنشور يُصحَّح بإصدار جديد برقمه.",
            en: "A draft goes to review first; a published release is corrected by a new one with its own version.",
        },
    },
    /**
     * **ولا يَنشر الكاتبُ ما كتب** — فمن يقرأ نصَّه يراه صحيحاً دائماً.
     *
     * وهو نفسُ حدّ التقارير: **من يكتب لا يُجيز**. ويُقاس عند النشر لا عند
     * الإرسال للمراجعة — فالكاتبُ يطلب المراجعةَ، وهو ما يُفترَض أن يفعله.
     */
    RELEASE_NOT_YOURS_TO_PUBLISH: {
        status: 403,
        messageKey: "errors.releaseNotYoursToPublish",
        cause: {
            ar: "محاولة نشر إصدارٍ كتبه الناشر نفسه.",
            en: "An attempt to publish a release written by the publisher themselves.",
        },
        remedy: {
            ar: "يقرؤه زميلٌ آخر وينشره — فمن يكتب لا يُجيز ما كتبه.",
            en: "A colleague reads and publishes it — the writer does not approve their own text.",
        },
    },
    /**
     * **ونصُّ إشعارٍ يحذف قوساً يُسلَّم بقوسٍ فارغ.**
     *
     * «اجتماعك بعد {when}» تصير «اجتماعك بعد» — **وهي رسالةٌ تكذب بأقصر طريق**:
     * تبدو جملةً صحيحةً ولا تقول شيئاً. فكلُّ قيمةٍ يُعلنها الحدثُ تبقى في النصّ
     * البديل، **ويُقال أيُّها نقص**.
     */
    NOTIFICATION_PARAM_MISSING: {
        status: 422,
        messageKey: "errors.notificationParamMissing",
        /**
         * **والرسالةُ تسمّي القوسَ الناقص وحده.**
         *
         * **فاسمُ الحدث لا يُعرَض**: من يقرأ الرسالةَ واقفٌ على صفّ ذلك الحدث
         * يعدّله — **فذكرُه تكرارٌ تقنيٌّ في وجه إنسان**. وكانت `event` مُعلَنةً
         * ولا موضعَ لها في النصّ، **فأمسكتها بوّابةُ «إعلانُه يطابق نصَّه»**.
         */
        contextKeys: ["missing"],
        cause: {
            ar: "النصّ البديل لا يحمل كل القيم التي يُعلنها الإشعار، فسيُسلَّم ناقصاً.",
            en: "The replacement text omits values the notification declares, so it would be delivered incomplete.",
        },
        remedy: {
            ar: "اترك الأقواس كما هي في مكانها من الجملة — {missing}.",
            en: "Keep the placeholders in your sentence — {missing}.",
        },
    },
    MEETING_OWN_PROPOSAL: {
        status: 422,
        messageKey: "errors.meetingOwnProposal",
        cause: {
            ar: "محاولة قبول أو رفض اقتراح موعدٍ من نفس الجهة التي اقترحته.",
            en: "An attempt to accept or decline a proposed time by the very side that proposed it.",
        },
        remedy: {
            ar: "الطرف الآخر هو من يقبل أو يرفض. ولو كان الموعد لم يعد مناسباً فاقترح غيره.",
            en: "The other side accepts or declines. If the time no longer suits, propose a different one.",
        },
    },
    /**
     * **والمؤكَّدُ يحمل رابطاً** — فاجتماعٌ مؤكَّدٌ بلا رابطٍ موعدٌ لا يحضره أحد.
     *
     * **والرابطُ يأتي من الوكالة** لأن الأداةَ أداتُها (زوم · مِيت): فحين تقترح
     * الوكالةُ موعداً تُرفِق رابطَه، **فيجد العميلُ رابطاً جاهزاً حين يقبل**. ولو
     * تُرك إلى ما بعد قبوله **لصار قبولُه موعداً بلا غرفة**.
     */
    MEETING_LINK_REQUIRED: {
        status: 422,
        messageKey: "errors.meetingLinkRequired",
        cause: {
            ar: "تأكيدُ اجتماعٍ أو اقتراحُ موعدٍ من الوكالة بلا رابط للأداة.",
            en: "Confirming a meeting, or the agency proposing a time, without the tool's link.",
        },
        remedy: {
            ar: "ضع رابط Zoom أو Meet مع الموعد — يراه العميل بعد التأكيد.",
            en: "Add the Zoom or Meet link with the time — the client sees it once it is confirmed.",
        },
    },
    MEETING_STATE_INVALID: {
        status: 409,
        messageKey: "errors.meetingStateInvalid",
        contextKeys: ["state"],
        cause: {
            ar: "الفعل المطلوب لا يصحّ على حالة الاجتماع الحالية — كتأكيد اجتماع ملغي، أو إلغاء اجتماع مرفوض.",
            en: "The requested action does not apply to the meeting's current state — confirming a cancelled meeting, or cancelling a rejected one.",
        },
        remedy: {
            ar: "حدّث الشاشة لترى حالته الحالية. والملغى أو المرفوض يُطلب من جديد بموعد جديد.",
            en: "Refresh to see its current state. A cancelled or declined meeting is requested afresh with a new time.",
        },
    },
    /**
     * **ولا يُقال «تمّ» قبل أن ينتهي** — فالحكمُ على ما وقع لا على ما سيقع.
     *
     * ومن يوسم اجتماعاً منتهياً قبل موعده **يُسقِط تذكيراته** ويُخرجه من قائمة
     * القادم، فيأتي الموعدُ ولا أحدَ ينتظره.
     */
    MEETING_NOT_OVER: {
        status: 409,
        messageKey: "errors.meetingNotOver",
        cause: {
            ar: "وسمُ اجتماعٍ بأنه تمّ أو أن الطرف الآخر لم يحضر قبل أن ينتهي وقته.",
            en: "Marking a meeting as held, or as a no-show, before its time has passed.",
        },
        remedy: {
            ar: "انتظر حتى ينتهي موعده. وإن كان لن يُعقد أصلاً فالإلغاء بسببه هو الصحيح.",
            en: "Wait until its time has passed. If it will not happen at all, cancelling with a reason is the right move.",
        },
    },
    ANALYTICS_LEVEL_NOT_ALLOWED: {
        status: 422,
        messageKey: "errors.analyticsLevelNotAllowed",
        contextKeys: ["metric", "level"],
        cause: {
            ar: "المقياس المطلوب غير معلَن لهذا المستوى في سجلّ المقاييس.",
            en: "The requested metric is not declared for this level in the metric registry.",
        },
        remedy: {
            ar: "الرسالة تسمّي المقياس والمستوى. والمستويات المسموحة لكل مقياس مكتوبة في سجلّه.",
            en: "The message names the metric and the level. Each metric's allowed levels are written in its registry entry.",
        },
    },
    ANALYTICS_GOAL_DUPLICATE: {
        status: 409,
        messageKey: "errors.analyticsGoalDuplicate",
        cause: {
            ar: "هناك هدف لنفس المقياس في نفس الشهر بالفعل.",
            en: "A target already exists for that metric in that month.",
        },
        remedy: {
            ar: "عدّل الهدف القائم بدل إنشاء ثانٍ — فرقمان مطلوبان لشيء واحد لا يُقاسان.",
            en: "Edit the existing target instead of adding a second — two required numbers for one thing cannot both be measured.",
        },
    },
    REPORT_MONTH_TAKEN: {
        status: 409,
        messageKey: "errors.reportMonthTaken",
        cause: {
            ar: "يوجد تقرير لهذا العميل عن الشهر نفسه بالفعل.",
            en: "There is already a report for this client covering the same month.",
        },
        remedy: {
            ar: "إن احتجت تقريراً ثانياً فعلاً، فاطلب استثناءً بسببه — والإدارة تبتّ فيه.",
            en: "If a second report is genuinely needed, request an exception with its reason — admin decides it.",
        },
    },
    /**
     * **ولا يراجع أحدٌ ما كتبه هو** (قرار شادي).
     *
     * فتقريرُ أداءٍ يصل عميلاً، **ومن يعتمد شغلَه بنفسه تصير المراجعةُ شكلاً**.
     * وهي قاعدةُ الفصل نفسُها التي منعت المنفّذَ من إجازة عنصر خطته.
     */
    REPORT_SELF_REVIEW: {
        status: 403,
        messageKey: "errors.reportSelfReview",
        cause: {
            ar: "هذا تقريرك أنت — ولا أحد يراجع ما كتبه بنفسه.",
            en: "This is your own report — nobody reviews what they wrote.",
        },
        remedy: {
            ar: "إن كنت رئيس القسم، فتقريرك يذهب إلى الإدارة مباشرة. تواصل معهم ليراجعوه.",
            en: "If you are the department head, your report goes straight to admin. Ask them to review it.",
        },
    },
    /** **والمعتمَدُ لا يُعدَّل في مكانه** — فالاعتمادُ على نصٍّ قُرئ */
    REPORT_LOCKED: {
        status: 409,
        messageKey: "errors.reportLocked",
        contextKeys: ["state"],
        cause: {
            ar: "هذا التقرير ليس في حالة تسمح بالتعديل — غالباً رُفع للمراجعة أو تمّت الموافقة عليه.",
            en: "This report is not in a state that allows editing — it was most likely submitted or approved.",
        },
        remedy: {
            ar: "إن تمّت الموافقة عليه ووصل إلى العميل، فعدّله بنسخة جديدة — وهي تمرّ بالمراجعتين من البداية.",
            en: "If it was approved and published, edit it as a new version — it goes through both reviews again.",
        },
    },
    REPORT_NOT_IN_REVIEW: {
        status: 409,
        messageKey: "errors.reportNotInReview",
        contextKeys: ["state"],
        cause: {
            ar: "هذا التقرير لا ينتظر مراجعتك الآن.",
            en: "This report is not waiting for your review right now.",
        },
        remedy: {
            ar: "افتح قائمة التقارير واعرض حالته — ربما رُوجع بالفعل أو عاد إلى صاحبه.",
            en: "Open the reports list and check its state — it may already be reviewed, or sent back to its author.",
        },
    },
    /**
     * **ولا نسختان معلّقتان لتقريرٍ واحد.**
     *
     * فمن يراجع لا يعرف أيَّهما يحلّ محلّ أيّ، **والعميلُ قد يرى الأقدمَ منهما**.
     */
    /** **وطلبُ تعديلٍ واحدٌ مفتوح** — فطلبان لا يعرف كاتبُه أيَّهما يصلح */
    REPORT_EDIT_ALREADY_ASKED: {
        status: 409,
        messageKey: "errors.reportEditAlreadyAsked",
        cause: {
            ar: "جهةُ اتصالٍ طلبت تعديلاً على هذا التقرير بالفعل، ولم تُعتمَد نسخةٌ جديدة بعد.",
            en: "A contact has already requested an edit to this report, and no new version has been approved yet.",
        },
        remedy: {
            ar: "الطلبُ الأول ظاهرٌ على التقرير بسببه — يُنفَّذ بنسخةٍ جديدة، وبها يُطوى.",
            en: "The first request shows on the report with its reason — a new version carries it out and clears it.",
        },
    },
    REPORT_VERSION_PENDING: {
        status: 409,
        messageKey: "errors.reportVersionPending",
        cause: {
            ar: "توجد نسخة جديدة من هذا التقرير بانتظار مراجعتها بالفعل.",
            en: "There is already a new version of this report waiting for review.",
        },
        remedy: {
            ar: "أنهِ النسخة المنتظرة أوّلاً — وافق عليها أو أعِدها إلى صاحبها، ثم أنشئ غيرها.",
            en: "Finish the pending version first — approve it or send it back — then make another.",
        },
    },
    REPORT_EXCEPTION_ALREADY_OPEN: {
        status: 409,
        messageKey: "errors.reportExceptionAlreadyOpen",
        cause: {
            ar: "يوجد طلب استثناء مفتوح لهذا العميل عن الشهر نفسه.",
            en: "There is already an open exception request for this client and month.",
        },
        remedy: {
            ar: "انتظر قرار الإدارة على الطلب القائم، أو تواصل معهم ليبتّوا فيه.",
            en: "Wait for the decision on the open request, or ask admin to decide it.",
        },
    },
    REPORT_EXCEPTION_DECIDED: {
        status: 409,
        messageKey: "errors.reportExceptionDecided",
        cause: {
            ar: "سبق البتّ في هذا الطلب.",
            en: "This request was already decided.",
        },
        remedy: {
            ar: "إن تغيّرت الظروف، فافتح طلباً جديداً بسببه.",
            en: "If things changed, open a new request with its reason.",
        },
    },
    /**
     * **ما نُشر لا يُعاد حجزُ موعده** — ولا يُوسَم مرّتين.
     *
     * فالوسمُ يقفل العنصر عند العميل. وإعادتُه **تحرّك ختمَ الوقت واسمَ الواسم**
     * إلى اليوم، فيضيع من نشره ومتى — وهو ما يُسأل عنه في النزاع.
     */
    PUBLICATION_ALREADY_PUBLISHED: {
        status: 409,
        messageKey: "errors.publicationAlreadyPublished",
        cause: {
            ar: "هذا الصفّ موسومٌ منشوراً بالفعل، ومعه إثباتُه ومن وسمه.",
            en: "This row is already marked published, with its proof and who marked it.",
        },
        remedy: {
            ar: "إن كان الوسم خاطئاً، فاسحبه بسببه — والسحب لرئيس قسم الوساطة وللمالك.",
            en: "If the mark is wrong, withdraw it with a reason — withdrawal belongs to the moderation head and the owner.",
        },
    },
    /**
     * **ولا يُسحَب وسمٌ لم يوضَع** — ولا يُطلَب إنزالُ ما لم يُنشَر.
     */
    PUBLICATION_NOT_PUBLISHED: {
        status: 409,
        messageKey: "errors.publicationNotPublished",
        cause: {
            ar: "هذا الصفّ لم يُوسَم منشوراً بعد، فلا وسمَ يُسحَب ولا محتوى حيٌّ يُنزَل.",
            en: "This row is not marked published yet, so there is no mark to withdraw and no live content to remove.",
        },
        remedy: {
            ar: "لو العنصر لم يَعُد مطلوباً أصلاً، اسحب موافقة العميل من شاشة الخطة — فتُلغى صفوفه.",
            en: "If the item is no longer wanted at all, withdraw the client approval from the plan screen — its rows are cancelled.",
        },
    },
    /** **والملغى خارج الطابور** — لا يُجدَّل ولا يُوسَم */
    PUBLICATION_CANCELLED: {
        status: 409,
        messageKey: "errors.publicationCancelled",
        cause: {
            ar: "هذا الصفّ أُلغي — غالباً لأن العنصر عُدّل بعد اعتماده فرجع للتنفيذ.",
            en: "This row was cancelled — usually because the item was edited after approval and went back to production.",
        },
        remedy: {
            ar: "راجع العنصر في خطته: لو رجع للتنفيذ، يحتاج موافقة عميلٍ جديدة فتُولَد صفوفٌ جديدة.",
            en: "Check the item in its plan: if it went back to production, it needs a fresh client approval, which generates new rows.",
        },
    },
    /**
     * **وطلبٌ مفتوحٌ واحدٌ لكل بوست.**
     *
     * فطلبان مفتوحان يعني أن يُقفَل أحدُهما **فيظنّ طالبُه أن الأمر انتهى**،
     * والآخرُ ما زال مفتوحاً عند غيره.
     */
    TAKEDOWN_ALREADY_OPEN: {
        status: 409,
        messageKey: "errors.takedownAlreadyOpen",
        cause: {
            ar: "يوجد طلب إزالة مفتوح على هذا المنشور بالفعل.",
            en: "There is already an open takedown request for this post.",
        },
        remedy: {
            ar: "افتح الطلب القائم وتابعه، أو أقفله بجوابه ثم افتح غيره إن لزم.",
            en: "Open the existing request and follow it, or close it with its answer and then open another if needed.",
        },
    },
    TAKEDOWN_ALREADY_RESOLVED: {
        status: 409,
        messageKey: "errors.takedownAlreadyResolved",
        cause: {
            ar: "هذا الطلب أُقفل من قبل، ومعه جوابُ من أقفله.",
            en: "This request was already closed, with the answer of whoever closed it.",
        },
        remedy: {
            ar: "لو المحتوى رجع أو لم يُنزَل فعلاً، افتح طلباً جديداً بسببه.",
            en: "If the content came back or was never really removed, open a new request with its reason.",
        },
    },
    /**
     * **لا بريدَ في هذا التنصيب** — ويُقال، ولا يُمثَّل.
     *
     * وهو منعُ v2 الحرفيّ: شاشةٌ تقول «بعتنا لك رابط» **ولا قناةَ وراءها**.
     * فالشاشةُ تسأل أوّلاً، وتُقفَل بنصّها إن لم يكن البريدُ مُهيَّأً — ولا
     * يصل هذا الكودُ إلى مستخدمٍ إلا إن نادى المسارَ بلا شاشة.
     */
    MAIL_NOT_CONFIGURED: {
        status: 409,
        messageKey: "errors.mailNotConfigured",
        cause: {
            ar: "البريد الصادر غير مضبوط في بيئة التشغيل: العنوان أو الحساب أو كلمة سرّ التطبيق غائبة.",
            en: "Outgoing mail is not set up in the runtime environment: the host, account, or app password is missing.",
        },
        remedy: {
            ar: "ضع إعدادات SMTP في بيئة التشغيل. وكلمة سرّ التطبيق هناك وحدها — لا في جدول الإعدادات ولا في المستودع.",
            en: "Put the SMTP settings in the runtime environment. The app password lives there alone — never in a settings table or the repository.",
        },
    },
    /**
     * **ورسالةٌ لم تخرج لا تُقال «خرجت».**
     *
     * فمن انتظر رابطَ استعادةٍ يجب أن يعرف أنه لم يُرسَل، **لا أن ينتظر ساعة**.
     * وسببُ المزوّد يُكتب في السجلّ لا في الشاشة: رسالتُه تحمل عنوانَه ومنفذَه
     * وأحياناً اسمَ الحساب، ولا شأنَ للمستخدم بها.
     */
    MAIL_SEND_FAILED: {
        status: 502,
        messageKey: "errors.mailSendFailed",
        cause: {
            ar: "خادم البريد رفض الرسالة أو لم يستجب. والسبب التفصيليّ في سجلّ النظام برقم الربط نفسه.",
            en: "The mail server refused the message or did not answer. The detailed reason is in the system log under the same correlation id.",
        },
        remedy: {
            ar: "افتح السجلّ برقم الربط. وأشهر الأسباب: كلمة سرّ تطبيق انتهت، أو منفذ مغلق في الشبكة، أو حساب أوقفه المزوّد.",
            en: "Open the log by correlation id. The usual causes: an expired app password, a port blocked on the network, or an account suspended by the provider.",
        },
    },
    /**
     * **رابطُ دعوةٍ لا يُفتَح به حساب** — ولا يُقال لماذا.
     *
     * فالأسبابُ أربعة: رمزٌ مجهول، أو منتهٍ، أو استُعمل، أو لحسابٍ موقوف.
     * **وتفريقُها يجعل المسار أداةً لمعرفة أيُّ الرموز حقيقيّ** — وهي أوّلُ خطوةٍ
     * في تخمينها. فكودٌ واحد للأربعة، وعلاجُه واحد: اطلب دعوةً جديدة.
     */
    INVITE_INVALID: {
        status: 400,
        messageKey: "errors.inviteInvalid",
        cause: {
            ar: "رابط الدعوة غير صالح: انتهت مدّته، أو استُعمل، أو الحساب موقوف.",
            en: "The invite link is not usable: it expired, was already used, or the account is suspended.",
        },
        remedy: {
            ar: "اطلب من الإدارة إعادة إرسال الدعوة — إعادةُ الإصدار تُبطل الرابط القديم وتعطي جديداً.",
            en: "Ask an administrator to send the invite again — reissuing invalidates the old link and gives a new one.",
        },
    },
    RATE_LIMITED: {
        status: 429,
        messageKey: "errors.rateLimited",
        cause: {
            ar: "محاولات أكثر من المسموح في النافذة الزمنية — غالباً دخول متكرّر أو نداء آلي.",
            en: "More attempts than allowed in the window — usually repeated sign-ins or an automated caller.",
        },
        remedy: {
            ar: "الانتظار يكفي. تكرارها من مصدر واحد يستحق النظر.",
            en: "Waiting is enough. Repeated from one source, worth a look.",
        },
    },
};
export const ERROR_CODES = Object.keys(errorCatalog);
/**
 * قراءة التعريف بنوعه الواسع.
 *
 * `as const satisfies` يضيّق كل إدخال إلى نوعه الحرفي، فالحقول الاختيارية لا
 * تظهر على الإدخالات التي لا تحملها. هذا الوصول يعيد `ErrorDefinition` كاملاً.
 */
export function errorDefinition(code) {
    return errorCatalog[code];
}
//# sourceMappingURL=catalog.js.map